import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { useIntl } from 'react-intl';
import { BookerContext } from '../Booker/index.js';
import classNames from 'classnames';
export const AddOnEmpty = ({ error, errorText }) => {
    const intl = useIntl();
    const { useTailwindPrefix } = useContext(BookerContext);
    return (_jsx("div", Object.assign({ className: classNames({
            'py-[1.9em] px-0 text-center': !useTailwindPrefix,
            'tw-py-[1.9em] tw-px-0 tw-text-center': useTailwindPrefix,
        }) }, { children: errorText || intl.formatMessage({ id: `daypass.empty${error ? '.error' : ''}` }) })));
};
